// Tab auto-selection effects for DashboardPage.
import { useEffect } from 'react';
import {
  TAB_COMPLETED,
  TAB_WAITING,
} from '@/features/dashboard/utils/dashboardPageUtils';

export function useDashboardTabEffects({
  searchParams,
  waitingTabIndex,
  isBattlefield,
  waitingCount,
  activeTabId,
  completedTabIndex,
  setDashTab,
}) {
  useEffect(() => {
    if (searchParams.get('tab') === 'waiting' && waitingTabIndex >= 0) {
      setDashTab(waitingTabIndex);
    }
  }, [searchParams, waitingTabIndex, setDashTab]);

  useEffect(() => {
    if (
      isBattlefield &&
      waitingCount === 0 &&
      activeTabId === TAB_WAITING &&
      searchParams.get('tab') !== 'waiting' &&
      completedTabIndex >= 0
    ) {
      setDashTab(completedTabIndex);
    }
  }, [
    isBattlefield,
    waitingCount,
    activeTabId,
    searchParams,
    completedTabIndex,
    setDashTab,
  ]);
}

export { TAB_COMPLETED, TAB_WAITING };
